import KEmitter from '../../core/mixins/emitter/KEmitter'
import KButton from '../button'
import { KeyCode } from '../../core/KConstants'
import $ from 'jquery'
import _ from 'lodash'

export default {
  name: 'KRadio',
  mixins: [KEmitter],
  model: {
    prop: 'checked',
    event: 'change',
  },
  props: {
    type: {
      type: String,
      default: 'primary',
    },
    name: {
      type: String,
      default: '',
    },
    checked: {
      validator: () => true,
      default: null,
    },
    value: {
      validator: () => true,
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    noRipple: {
      type: Boolean,
      default: true,
    },
    small: {
      type: Boolean,
      default: false,
    },
    pure: {
      type: Boolean, // 不显示默认样式和模板
      default: false,
    },
  },
  data() {
    return {
      isButton: false,
      innerChecked: false,
    }
  },
  computed: {

  },
  watch: {
    checked: {
      immediate: true,
      handler(checked) {
        if (_.isNil(this.value)) {
          this.innerChecked = checked
        } else {
          this.innerChecked = checked === this.value
        }
      },
    },
    innerChecked(value) {
      if (this.isButton) {
        return
      }
      if (value) {
        this.$emit('change', _.isNil(this.value) ? true : this.value)
      } else {
        this.$refs.input.checked = false
      }
    },
  },
  mounted() {
  },
  render() {
    const attrs = {
      attrs: {
        tabindex: 0,
      },
    }

    const radioCss = {
      class: {
        'km-radio': true,
        'is-disabled': this.disabled,
        'km-radio--checked': this.innerChecked,
        'km-radio--small': this.small,
        [`km-radio--${this.type}`]: true,
      },
    }

    if (this.pure) {
      return (
        <label
          {...radioCss}
          {...attrs}
          onClick={this.handleLabelClick}
          onKeydown={this.handleKeydown}
        >
          {this.renderOriginalInput()}
          {this.renderLabel()}
        </label>
      )
    }

    if (!this.isButton) {
      const icon = this.renderIcon()
      const label = this.renderLabel()
      return (
        <label
          {...radioCss}
          {...attrs}
          onClick={this.handleLabelClick}
          onKeydown={this.handleKeydown}
        >
          {icon}
          {label}
        </label>
      )
    }

    const buttonLabel = this.renderButtonLabel(radioCss.class)

    return buttonLabel
  },
  methods: {
    renderOriginalInput() {
      return (
        <input
          class="km-radio__input"
          ref="input"
          name={this.name || this.attrName}
          type="radio"
          disabled={this.disabled}
          onClick={this.handleInputClick}
          onChange={this.handleChange}
        />
      )
    },
    renderButtonLabel(radioCss) {
      const css = _.assign(radioCss, {
        'km-radio-button': true,
      })

      const props = {
        type: this.innerChecked ? this.checkedType : this.uncheckedType,
        rounded: this.capsule && this.capsuleType === 'rounded',
      }

      if (this.size) {
        props.size = this.size
      }

      if (this.checkedTheme === this.uncheckedTheme) {
        props[this.checkedTheme] = true
      } else {
        props[this.checkedTheme] = this.innerChecked
        props[this.uncheckedTheme] = !this.innerChecked
      }

      const originalInput = this.renderOriginalInput()

      return (
        <KButton
          {...{ props: props }}
          {...{ class: css }}
          {...{ attrs: { tabindex: 0 } }}
          type={this.type}
          tag="label"
          onKeydown={this.handleKeydown}
        >
          {originalInput}
          {this.$slots.default}
        </KButton>
      )
    },
    renderLabel() {
      return <div class="km-radio__label">{this.$slots.default}</div>
    },
    renderIcon() {
      const ripple = this.renderRipple()

      const iconCss = {
        class: {
          'km-radio__icon--checked': this.innerChecked,
        },
      }

      const originalInput = this.renderOriginalInput()

      return (
        <div class="km-radio__icon" {...iconCss}>
          {originalInput}
          <span class="km-radio__icon-dot" />
          {this.noRipple ? null : ripple}
        </div>
      )
    },
    renderRipple() {
      return (
        <KButton
          class="km-radio__ripple"
          disabled={this.disabled}
          onClick={this.handleButtonClick}
          ref="button"
          circle
          plain
          size={this.small ? 'small' : ''}
          type={this.type}
        />
      )
    },
    handleKeydown(e) {
      if (e.which === KeyCode.ENTER) {
        $(this.$el).trigger('click')
      }
    },
    handleButtonClick() {
      this.$refs.input.click()
    },
    handleLabelClick() {
      // this.$refs.button && this.$refs.button.emulateForceClick(100)
    },
    handleChange(e) {
      const checked = e.target.checked
      this.innerChecked = checked
      this.$nextTick(() => {
        this.dispatch('KFormItem', 'k.form.change', [this.checked])
      })
    },
    handleInputClick(e) { // prevent native click on label triggers twice
      if (this.cancelable) {
        this.radioGroup.handleValueChange(null)
      }
      e.stopPropagation()
    },
  },
}
